import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1359d2e4&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1359d2e4&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1359d2e4')) {
      api.createRecord('1359d2e4', component.options)
    } else {
      api.reload('1359d2e4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1359d2e4&", function () {
      api.rerender('1359d2e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/charts/vacations/components/table/workers-list/index.vue"
export default component.exports